<template>
  <router-link :to="'/dashboard/dealer/purchase_orders/' + id + '?origin=' + origin">
    <slot v-if="$slots.content" name="content"></slot>
    <span v-else>{{ number }}</span>
  </router-link>
</template>
<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0
    },
    number: {
      type: String,
      default: ''
    },
    origin: {
      type: Number,
      default: 0
    }
  }
}
</script>